import {
  AuthFlowComplete,
  AuthFlowId,
  AuthStepDefinition,
  AuthStepId,
  AuthStepRoute,
  AuthTransitionKey,
} from '../../models/auth-flow.models';

export const CONFIRM_EMAIL_STEP: AuthStepDefinition = {
  id: AuthStepId.CONFIRM_EMAIL,
  route: AuthStepRoute.Code,
  back: AuthStepId.ENTER_EMAIL,
  next: {
    [AuthFlowId.Login]: {
      [AuthTransitionKey.HasAccounts]: AuthStepId.SELECT_ACCOUNT,
      [AuthTransitionKey.NeedTel]: AuthStepId.TEL_VERIFICATION,
      [AuthTransitionKey.Default]: AuthFlowComplete.Complete,
    },
    [AuthFlowId.Registration]: {
      [AuthTransitionKey.NeedTel]: AuthStepId.TEL_VERIFICATION,
      [AuthTransitionKey.Default]: AuthStepId.ONBOARDING,
    },
  },
};
